// Analytics.js
import mixpanel from "mixpanel-browser";

// Replace with your project token
const MIXPANEL_TOKEN = "dde99e449223380f957333786bb7c414";

mixpanel.init(MIXPANEL_TOKEN, {
	debug: false,
	track_pageview: false,
	autotrack: false,
	persistence: "localStorage",
});

// Register
export function mixpanelStart(data) {
	// Determine environment based on hostname
	const hostname = window.location.hostname;
	const env = hostname === "recoveryiq.openrecovery.com" ? "prod" : "dev";

	const anonId = mixpanel.get_distinct_id();
	const alreadyIdentified = mixpanel.get_property("$identified_id");

	if (!alreadyIdentified && anonId !== data.user_id) {
		mixpanel.alias(data.user_id, anonId);
	}

	console.log("mixpanel identify: ", data.user_id);
	mixpanel.identify(data.user_id); // OUR internal unique user_id
	const mixpanelPeopleData = {
		env: env,
	};
	console.log("Mixpanel people: ", mixpanelPeopleData);
	mixpanel.people.set(mixpanelPeopleData);
	const mixpanelRegisterData = {
		compliance_required: data.require_compliance || null,
		survey_id: data.survey_id || null,
		env: env,
		domain: window.location.hostname,
	};
	console.log("mixpanel register: ", mixpanelRegisterData);
	mixpanel.register(mixpanelRegisterData);
}

export default mixpanel;
